import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import { isMobile } from "react-device-detect";
import Dialog from "../Dialog";
import { workContentService } from "../../services/WorkContentService";

/**
 * 間接・無負荷・停止ロス作業内容詳細ダイアログコンポーネント
 * @param {boolean} open ダイアログの開閉フラグ
 * @param {Function} onClose ダイアログを閉じる際の処理
 * @param {number} interruptWorkId 割込み作業ID
 * @param {string} type 作業種別（間接・無負荷・停止ロス）
 * @class InterruptWorkDetailDialod
 */
export default function InterruptWorkDetailDialod({
  open,
  onClose,
  interruptWorkId,
  type,
}) {
  const [interruptWork, setInterruptWork] = useState(null);

  /**
   * 対象の作業内容詳細を取得する
   * @memberof InterruptWorkDetailDialod
   */
  useEffect(() => {
    const getData = async () => {
      try {
        if (type === "indirect") {
          const result = (await workContentService.getIndirect(interruptWorkId))
            .data;
          if (result.success) {
            setInterruptWork({
              ...result.body,
              title: result.body?.indirectWorkLabel,
            });
          }
        }
        if (type === "noload") {
          const result = (await workContentService.getNoload(interruptWorkId))
            .data;
          if (result.success) {
            setInterruptWork({
              ...result.body,
              title: result.body?.noloadWorkLabel,
            });
          }
        }
        if (type === "stoploss") {
          const result = (await workContentService.getStoploss(interruptWorkId))
            .data;
          if (result.success) {
            setInterruptWork({
              ...result.body,
              title: result.body?.stoplossWorkLabel,
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    };
    if (open) {
      getData();
    }
  }, [open, interruptWorkId, type]);
  /**
   * 作業内容詳細をリセットしダイアログを閉じる
   * @memberof InterruptWorkDetailDialod
   */
  const onDialogClose = () => {
    setInterruptWork(null);
    onClose();
  };

  return (
    <Dialog
      open={open && interruptWork}
      title={interruptWork?.title}
      onClose={onDialogClose}
    >
      <TableContainer
        id="interrupt-work-content-table"
        className={isMobile ? "mobile" : ""}
      >
        <Table size="small">
          <TableBody>
            <TableRow>
              <TableCell component="th">開始時刻</TableCell>
              <TableCell>{interruptWork?.startedAt}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">終了時刻</TableCell>
              <TableCell>{interruptWork?.endedAt}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">機種</TableCell>
              <TableCell>{interruptWork?.modelTypeLabel}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component="th">機番</TableCell>
              <TableCell>{interruptWork?.modelNumberLabel}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Dialog>
  );
}
